<template>
  <div id="">
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item>日报管理</el-breadcrumb-item>
      <el-breadcrumb-item>日报列表</el-breadcrumb-item>
    </el-breadcrumb>
    <div class="row">
      <div class="col-sm-7">
        <div class="panel">
          <el-page-header
            @back="$router.go(-1)"
            :content="model.id ? '编辑日报' : '添加日报'"
          >
          </el-page-header>
          <div class="form-horizontal m-t-20">
            <el-form :model="model" :rules="rules" ref="ruleForm">
              <div class="row">
                <div class="col-lg-12">
                  <div class="form-group col-sm-6">
                    <label class="col-md-4 control-label">所属日期</label>
                    <div class="col-md-8">
                      <el-form-item label="" prop="day">
                        <el-date-picker
                          style="width: 100%"
                          v-model="model.day"
                          value-format="yyyy-MM-dd"
                          type="date"
                          size="small"
                          placeholder="选择日期时间"
                        >
                        </el-date-picker>
                      </el-form-item>
                    </div>
                  </div>
                </div>
                <div class="col-lg-12 mt-30">
                  <div class="form-group col-sm-6">
                    <label class="col-md-4 control-label">当前井深(m)</label>
                    <div class="col-md-8">
                      <el-form-item label="" prop="current_pit_depth">
                        <el-input
                          v-model="model.current_pit_depth"
                          size="small"
                        ></el-input>
                      </el-form-item>
                    </div>
                  </div>
                  <div class="form-group col-sm-6">
                    <label class="col-md-4 control-label">日进尺(m)</label>
                    <div class="col-md-8">
                      <el-form-item label="" prop="day_drilling_footage">
                        <el-input
                          v-model="model.day_drilling_footage"
                          size="small"
                        ></el-input>
                      </el-form-item>
                    </div>
                  </div>
                  <div class="form-group col-sm-6">
                    <label class="col-md-4 control-label">班进尺(m)</label>
                    <div class="col-md-8">
                      <el-form-item label="" prop="class_drilling_footage">
                        <el-input
                          v-model="model.class_drilling_footage"
                          size="small"
                        ></el-input>
                      </el-form-item>
                    </div>
                  </div>
                  <div class="form-group col-sm-6">
                    <label class="col-md-4 control-label">地层</label>
                    <div class="col-md-8">
                      <el-form-item label="" prop="stratum">
                        <el-input
                          v-model="model.stratum"
                          size="small"
                        ></el-input>
                      </el-form-item>
                    </div>
                  </div>
                  <div class="form-group col-sm-6">
                    <label class="col-md-4 control-label">岩性</label>
                    <div class="col-md-8">
                      <el-input
                        v-model="model.rock_character"
                        size="small"
                      ></el-input>
                    </div>
                  </div>

                  <div class="form-group col-sm-12">
                    <label class="col-md-2 control-label dl-title"
                      >钻井参数</label
                    >
                  </div>
                  <div class="form-group col-sm-6">
                    <label class="col-md-4 control-label">转速(r/min)</label>
                    <div class="col-md-8">
                      <el-input
                        v-model="model.rotationl_speed"
                        size="small"
                      ></el-input>
                    </div>
                  </div>
                  <div class="form-group col-sm-6">
                    <label class="col-md-4 control-label">排量(L/S)</label>
                    <div class="col-md-8">
                      <el-input
                        v-model="model.displacement"
                        size="small"
                      ></el-input>
                    </div>
                  </div>
                  <div class="form-group col-sm-6">
                    <label class="col-md-4 control-label">泵压(MPa)</label>
                    <div class="col-md-8">
                      <el-input
                        v-model="model.pumping_pressure"
                        size="small"
                      ></el-input>
                    </div>
                  </div>
                  <div class="form-group col-sm-6">
                    <label class="col-md-4 control-label">钻压(T)</label>
                    <div class="col-md-8">
                      <el-input
                        v-model="model.drill_pressure"
                        size="small"
                      ></el-input>
                    </div>
                  </div>

                  <div class="form-group col-sm-12">
                    <label class="col-md-2 control-label dl-title"
                      >泥浆参数</label
                    >
                  </div>
                  <div class="form-group col-sm-6">
                    <label class="col-md-4 control-label"
                      >泥浆密度(g/cm³)</label
                    >
                    <div class="col-md-8">
                      <el-input
                        v-model="model.mud_density"
                        size="small"
                      ></el-input>
                    </div>
                  </div>
                  <div class="form-group col-sm-6">
                    <label class="col-md-4 control-label">粘度(s)</label>
                    <div class="col-md-8">
                      <el-input
                        v-model="model.mud_viscosity"
                        size="small"
                      ></el-input>
                    </div>
                  </div>

                  <div class="form-group col-sm-12">
                    <label class="col-md-2 control-label dl-title"
                      >轨迹参数</label
                    >
                  </div>
                  <div class="form-group col-sm-6">
                    <label class="col-md-4 control-label">测深(m)</label>
                    <div class="col-md-8">
                      <el-input
                        v-model="model.trail_depth"
                        size="small"
                      ></el-input>
                    </div>
                  </div>
                  <div class="form-group col-sm-6">
                    <label class="col-md-4 control-label">井斜(°)</label>
                    <div class="col-md-8">
                      <el-input
                        v-model="model.tilt_degree"
                        size="small"
                      ></el-input>
                    </div>
                  </div>
                  <div class="form-group col-sm-6">
                    <label class="col-md-4 control-label">磁方位(°)</label>
                    <div class="col-md-8">
                      <el-input
                        v-model="model.magnetism_direction"
                        size="small"
                      ></el-input>
                    </div>
                  </div>
                  <div class="form-group col-sm-6">
                    <label class="col-md-4 control-label">场强(nT)</label>
                    <div class="col-md-8">
                      <el-input
                        v-model="model.field_strength"
                        size="small"
                      ></el-input>
                    </div>
                  </div>
                  <div class="form-group col-sm-6">
                    <label class="col-md-4 control-label">倾角(°)</label>
                    <div class="col-md-8">
                      <el-input
                        v-model="model.dip_angle"
                        size="small"
                      ></el-input>
                    </div>
                  </div>
                  <div class="form-group col-sm-6">
                    <label class="col-md-4 control-label">重力(G)</label>
                    <div class="col-md-8">
                      <el-input v-model="model.gravity" size="small"></el-input>
                    </div>
                  </div>

                  <div class="form-group col-sm-6 mt-30">
                    <label class="col-md-4 control-label">钻具组合</label>
                    <div class="col-md-8">
                      <el-input
                        type="textarea"
                        autosize
                        v-model="model.drilling_tools"
                        size="small"
                      ></el-input>
                    </div>
                  </div>

                  <div class="form-group col-sm-6 mt-30">
                    <label class="col-md-4 control-label">当前工况</label>
                    <div class="col-md-8">
                      <el-input
                        type="textarea"
                        autosize
                        v-model="model.working_condition"
                        size="small"
                      ></el-input>
                    </div>
                  </div>

                  <div class="form-group col-sm-12">
                    <label class="col-md-2 control-label">钻进状态</label>
                    <div class="col-md-10">
                      <el-form-item label="" prop="drill_status">
                        <el-radio-group v-model="model.drill_status">
                          <el-radio :label="4">起钻</el-radio>
                          <el-radio :label="1">下钻</el-radio>
                          <el-radio :label="2">钻进</el-radio>
                          <el-radio :label="3">其他</el-radio>
                        </el-radio-group>
                      </el-form-item>
                    </div>
                  </div>

                  <div class="form-group col-sm-12">
                    <label class="col-md-2 control-label dl-title">仪器</label>
                  </div>
                  <div class="form-group col-sm-6">
                    <label class="col-md-4 control-label">厂家</label>
                    <div class="col-md-8">
                      <el-input
                        v-model="model.instrument_manufactor"
                        size="small"
                      ></el-input>
                    </div>
                  </div>
                  <div class="form-group col-sm-6">
                    <label class="col-md-4 control-label">编号</label>
                    <div class="col-md-8">
                      <el-input
                        v-model="model.instrument_number"
                        size="small"
                      ></el-input>
                    </div>
                  </div>
                  <div class="form-group col-sm-6">
                    <label class="col-md-4 control-label">探管</label>
                    <div class="col-md-8">
                      <el-input
                        v-model="model.instrument_probe_tube"
                        size="small"
                      ></el-input>
                    </div>
                  </div>
                  <div class="form-group col-sm-6">
                    <label class="col-md-4 control-label">脉冲</label>
                    <div class="col-md-8">
                      <el-input
                        v-model="model.instrument_pulse"
                        size="small"
                      ></el-input>
                    </div>
                  </div>
                  <div class="form-group col-sm-6">
                    <label class="col-md-4 control-label">电池</label>
                    <div class="col-md-8">
                      <el-input
                        v-model="model.instrument_battery"
                        size="small"
                      ></el-input>
                    </div>
                  </div>
                  <div class="form-group col-sm-6">
                    <label class="col-md-4 control-label">驱动</label>
                    <div class="col-md-8">
                      <el-input
                        v-model="model.instrument_driver"
                        size="small"
                      ></el-input>
                    </div>
                  </div>
                  <div class="form-group col-sm-6">
                    <label class="col-md-4 control-label">使用时间(h)</label>
                    <div class="col-md-8">
                      <el-input
                        v-model="model.instrument_use_time"
                        size="small"
                      ></el-input>
                    </div>
                  </div>

                  <div class="form-group col-sm-12">
                    <label class="col-md-2 control-label dl-title">螺杆</label>
                  </div>
                  <div class="form-group col-sm-6">
                    <label class="col-md-4 control-label">型号</label>
                    <div class="col-md-8">
                      <el-input
                        v-model="model.screw_model"
                        size="small"
                      ></el-input>
                    </div>
                  </div>
                  <div class="form-group col-sm-6">
                    <label class="col-md-4 control-label">厂家</label>
                    <div class="col-md-8">
                      <el-input
                        v-model="model.screw_manufactor"
                        size="small"
                      ></el-input>
                    </div>
                  </div>
                  <div class="form-group col-sm-6">
                    <label class="col-md-4 control-label">尺寸</label>
                    <div class="col-md-8">
                      <el-input
                        v-model="model.screw_size"
                        size="small"
                      ></el-input>
                    </div>
                  </div>
                  <div class="form-group col-sm-6">
                    <label class="col-md-4 control-label">编号</label>
                    <div class="col-md-8">
                      <el-input
                        v-model="model.screw_number"
                        size="small"
                      ></el-input>
                    </div>
                  </div>
                  <div class="form-group col-sm-6">
                    <label class="col-md-4 control-label">循环时间(h)</label>
                    <div class="col-md-8">
                      <el-input
                        v-model="model.screw_loop_time"
                        size="small"
                      ></el-input>
                    </div>
                  </div>

                  <div class="form-group col-sm-12">
                    <label class="col-md-2 control-label dl-title">钻头</label>
                  </div>
                  <div class="form-group col-sm-6">
                    <label class="col-md-4 control-label">厂家</label>
                    <div class="col-md-8">
                      <el-input
                        v-model="model.drill_manufactor"
                        size="small"
                      ></el-input>
                    </div>
                  </div>
                  <div class="form-group col-sm-6">
                    <label class="col-md-4 control-label">型号</label>
                    <div class="col-md-8">
                      <el-input
                        v-model="model.drill_model"
                        size="small"
                      ></el-input>
                    </div>
                  </div>
                  <div class="form-group col-sm-6">
                    <label class="col-md-4 control-label">尺寸</label>
                    <div class="col-md-8">
                      <el-input
                        v-model="model.drill_size"
                        size="small"
                      ></el-input>
                    </div>
                  </div>
                  <div class="form-group col-sm-6">
                    <label class="col-md-4 control-label">序列号</label>
                    <div class="col-md-8">
                      <el-input
                        v-model="model.drill_number"
                        size="small"
                      ></el-input>
                    </div>
                  </div>
                  <div class="form-group col-sm-6">
                    <label class="col-md-4 control-label">总纯钻时间(h)</label>
                    <div class="col-md-8">
                      <el-input
                        v-model="model.drill_total_time"
                        size="small"
                      ></el-input>
                    </div>
                  </div>
                  <div class="form-group col-sm-6">
                    <label class="col-md-4 control-label">总进尺(m)</label>
                    <div class="col-md-8">
                      <el-input
                        v-model="model.drill_total_footage"
                        size="small"
                      ></el-input>
                    </div>
                  </div>
                  <div class="form-group col-sm-6">
                    <label class="col-md-4 control-label"
                      >最快钻时(m/min)</label
                    >
                    <div class="col-md-8">
                      <el-input
                        v-model="model.drill_max_speed"
                        size="small"
                      ></el-input>
                    </div>
                  </div>
                  <div class="form-group col-sm-6">
                    <label class="col-md-4 control-label"
                      >最慢钻时(m/min)</label
                    >
                    <div class="col-md-8">
                      <el-input
                        v-model="model.drill_min_speed"
                        size="small"
                      ></el-input>
                    </div>
                  </div>
                  <div class="form-group col-sm-6">
                    <label class="col-md-4 control-label"
                      >定向钻时(m/min)</label
                    >
                    <div class="col-md-8">
                      <el-input
                        v-model="model.drill_directional_time"
                        size="small"
                      ></el-input>
                    </div>
                  </div>
                  <div class="form-group col-sm-6">
                    <label class="col-md-4 control-label"
                      >当班机械钻速(m/h)</label
                    >
                    <div class="col-md-8">
                      <el-input
                        v-model="model.drill_current_speed"
                        size="small"
                      ></el-input>
                    </div>
                  </div>
                  <div class="form-group col-sm-6">
                    <label class="col-md-4 control-label"
                      >总平均机械钻速(m/h)</label
                    >
                    <div class="col-md-8">
                      <el-input
                        v-model="model.drill_average_speed"
                        size="small"
                      ></el-input>
                    </div>
                  </div>

                  <div class="form-group col-sm-12">
                    <label class="col-md-2 control-label dl-title">其它</label>
                  </div>

                  <div class="form-group col-sm-6">
                    <label class="col-md-4 control-label">循环温度(℃)</label>
                    <div class="col-md-8">
                      <el-input
                        v-model="model.loop_temperature"
                        size="small"
                      ></el-input>
                    </div>
                  </div>
                  <div class="col-sm-12 pad-no">
                    <div class="form-group col-sm-6">
                      <label class="col-md-4 control-label">驻井人员</label>
                      <div class="col-md-8">
                        <el-input
                          v-model="model.resident_person"
                          size="small"
                        ></el-input>
                      </div>
                    </div>
                  </div>
                  <div class="col-sm-12 pad-no">
                    <div class="form-group col-sm-6">
                      <label class="col-md-4 control-label">备注</label>
                      <div class="col-md-8">
                        <el-input
                          type="textarea"
                          autosize
                          v-model="model.remark"
                          size="small"
                        ></el-input>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </el-form>
          </div>
          <div class="panel-footer">
            <div class="row">
              <div class="col-lg-4 col-md-6">
                <div class="col-md-8 col-md-offset-4">
                  <el-button type="primary" size="small" @click="submit"
                    >提交</el-button
                  >
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-sm-5">
        <div class="panel">
          <div class="panel-heading">
            <h3 class="panel-title">项目信息</h3>
          </div>
          <div class="panel-body">
            <dl class="dl-horizontal">
              <dt>井号</dt>
              <dd>{{ project.pit_number }}</dd>
              <dt>井队</dt>
              <dd>{{ project.pit_team }}</dd>
              <dt>位置</dt>
              <dd>{{ project.position }}</dd>
              <dt>服务内容</dt>
              <dd>{{ project.service }}</dd>
              <dt>主眼设计井深</dt>
              <dd>{{ project.pit_depth }} m</dd>
              <dt>服务开始日期</dt>
              <dd>
                {{
                  project.start_time
                    ? $time(project.start_time).format('YYYY-MM-DD')
                    : ''
                }}
              </dd>
              <dt>当前钻进周期</dt>
              <dd>{{ project.show_worked_day }}天</dd>
            </dl>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  reportNew,
  reportUpdate,
  reportDetail,
  projectDetail,
} from '../../../service/getData'
export default {
  data() {
    return {
      rules: {
        day: [{ required: true, message: '此项不能为空', trigger: 'change' }],
        current_pit_depth: [
          { required: true, message: '此项不能为空', trigger: 'blur' },
        ],
        day_drilling_footage: [
          { required: true, message: '此项不能为空', trigger: 'blur' },
        ],
        class_drilling_footage: [
          { required: true, message: '此项不能为空', trigger: 'blur' },
        ],
        drill_status: [
          { required: true, message: '请选择钻进状态', trigger: 'change' },
        ],
      },
      model: {
        admin_id: 1,
        project_id: 0,
        day: '',
        drill_status: '',
        current_pit_depth: '',
        day_drilling_footage: '',
        class_drilling_footage: '',
        stratum: '',
        rock_character: '',
        rotationl_speed: '',
        displacement: '',
        pumping_pressure: '',
        drill_pressure: '',
        mud_density: '',
        mud_viscosity: '',
        trail_depth: '',
        tilt_degree: '',
        magnetism_direction: '',
        field_strength: '',
        dip_angle: '',
        gravity: '',
        drilling_tools: '',
        working_condition: '',
        instrument_manufactor: '',
        instrument_number: '',
        instrument_probe_tube: '',
        instrument_pulse: '',
        instrument_battery: '',
        instrument_driver: '',
        instrument_use_time: '',
        screw_model: '',
        screw_manufactor: '',
        screw_size: '',
        screw_number: '',
        screw_loop_time: '',
        drill_manufactor: '',
        drill_model: '',
        drill_size: '',
        drill_number: '',
        drill_total_time: '',
        drill_total_footage: '',
        drill_max_speed: '',
        drill_min_speed: '',
        drill_directional_time: '',
        drill_current_speed: '',
        drill_average_speed: '',
        loop_temperature: '',
        resident_person: '',
        remark: '',
      },
      project: {},
    }
  },
  created() {
    if (this.$route.query.project_id) {
      this.getProject(this.$route.query.project_id)
    }

    if (this.$route.params.id) {
      this.getDetail(this.$route.params.id)
    }
  },
  methods: {
    async getProject(id) {
      let res = await projectDetail(id)
      this.project = res.data
    },
    submit() {
      this.$refs.ruleForm.validate(async (valid) => {
        if (valid) {
          if (this.model.id) {
            let res = await reportUpdate(this.model)
            if (res.code == 0) {
              this.$router.go(-1)
            }
          } else {
            this.model.project_id = this.project.id
            let res = await reportNew(this.model)
            if (res.code == 0) {
              this.$router.go(-1)
            }
          }
        }
      })
    },
    async getDetail(id) {
      let res = await reportDetail(id)
      if (!res.data.drill_status) {
        res.data.drill_status = ''
      }
      this.model = res.data
      this.project = res.data.project
    },
  },
}
</script>